import { BufferedLogger } from './buffered-logger';
import { Logger } from './logger';

/**
 * A single, shared instance of the {@link BufferedLogger} for the entire application.
 * Import this instance to ensure all logs are collected in the same buffer.
 */
export const bufferedLogger = new BufferedLogger();

/**
 * A single, shared instance of the {@link Logger} for general-purpose logging.
 * Import this instance to log messages that automatically respect the running environment
 * (backend vs. browser) and the user's debug configuration (conditional logging).
 */
export const logger = new Logger();
